import { mapGetters } from 'vuex';
import { GcLoader } from '@garmin/components-global';
import CloseSVG from '@/assets/icons/close.svg';
import ProductSpinner from '../ProductSpinner/index.vue';

export default {
  name: 'ProductViewer',
  data() {
    return {
      className: 'app__product__viewer',
      jsId: 'js__spinner',
    };
  },
  computed: {
    ...mapGetters({
      partNumber: 'getPartNumber',
      images: 'getProductSpinnerImagesBySku',
    }),
    closeJsId() {
      return `${this.jsId}__close`;
    },
    closeClass() {
      return `${this.className}__close`;
    },
    closeSvgClass() {
      return `${this.closeClass}__svg`;
    },
    containerClass() {
      return `${this.className}__container`;
    },
    contentClass() {
      return `${this.className}__content`;
    },
    spinnerClass() {
      return `${this.className}__spinner`;
    },
    loaderClass() {
      return `${this.spinnerClass}__loader`;
    },
    getCurrentImages() {
      return this.images(this.partNumber) || [];
    },
  },
  methods: {
    closeViewer() {
      this.$router.push({
        name: 'FullPath',
        params: this.$router.currentRoute.params,
        hash: this.$router.currentRoute.hash,
      });
    },
  },
  components: {
    ProductSpinner,
    GcLoader,
    CloseSVG,
  },
};
